import React, { FunctionComponent } from "react";
import ReactLoading from "react-loading";
import styles from "./NewLoading.module.css";
import LogoNew from "../../Assets/Images/IFY_Magicbricks_Logo.png";
import { connect } from "react-redux";

type props = {
  logo?: boolean;
  progress: any;
  theme:any;
  role:any;
  subtext?: boolean;
};

const NewLoading: FunctionComponent<props> = ({ logo, progress,theme,role,subtext }) => {
  return (
        <div className={styles.parent} style={{ width:"100vw",zIndex: 10000}}>
    <ReactLoading
        type={"bars"}
        color={"#279f9f"}
        height={90}
        width={90}
        className={styles.loader}
      />
           {subtext && (
        <p
          style={{
            marginTop: "-2rem",
            marginLeft: "-2rem",
            color: "#279f9f",
            fontSize: "1.25rem",
            fontWeight: 700,
          }}
        >
          Please wait, we are processing your data...
        </p>
      )}
      {logo && (
        <img
          src={LogoNew}
          alt={"Logo"}
          style={{ position: "fixed", bottom: 50 }}
        />
      )}
      {progress.total !== 0 && (
        <p
          style={{
            marginTop: "60px",
            color: "#2FA2D3",
            fontSize: "24px",
            fontWeight: 600,
          }}
        >
          {progress.completed} / {progress.total} Completed
        </p>
      )}
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    progress: state.progress,
    theme: state.theme.isLightMode,
    role: state.user.role,
  };
};

export default connect(mapStateToProps)(NewLoading);
